import { render } from "./autoSuggest.vue?vue&type=template&id=762a1fe0"
import script from "./autoSuggest.vue?vue&type=script&lang=js"
export * from "./autoSuggest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__